import type { ReactElement } from 'react';
import { DefaultLayout } from '@/layouts/index';
import { useClient } from '@/hooks';

function WaitAnalysis(): ReactElement {
  const { currentState } = useClient();
  const scoreBackgroundCheckCopy =
    currentState === 'score_background_check'
      ? 'da pessoa avalista'
      : 'das pessoas avalistas';

  return (
    <DefaultLayout
      title="Aguarde a análise de crédito"
      titleAlign="left"
      cardSize="normal-card"
      step="3 de 4"
      description=""
      progressPercentage={75}
    >
      <div className="wait-analysis-container">
        <img
          src="/assets/images/rocket.svg"
          alt="rocket taking off"
          className="wait-analysis-container__image"
        />
        <div className="wait-analysis-container__feedback-text">
          <p className="wait-analysis-container__feedback-text--description">
            Agora vamos analisar seus dados e {scoreBackgroundCheckCopy}.
            Devemos entrar em contato com você por e-mail em até 7 dias
            corridos. 💚
          </p>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default WaitAnalysis;
